module.exports = __webpack_public_path__ + "static/media/BAR.68360259.jpg";